export default function selectMe(el){
	console.log(el);
  //e.preventDefault;
    el ? 
    document.getElementById(el).select()
    :
    document.getElementById('selectable').select();
}
